// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__zx_tB","list":"PatternAutocomplete_list__CUC1e"};